import React from 'react';
import testimonials from '../data/testimonials';
import Icons from './Icons';

export default function Testimonials() {
	return (
		<section className="py-12 bg-white">
			<div className="max-w-7xl mx-auto px-4">
				<h2 className="text-3xl font-bold mb-6">Testimonios</h2>
				<div className="grid md:grid-cols-3 gap-6">
					{testimonials.map(t => (
						<div key={t.id} className="bg-slate-50 p-6 rounded-lg">
							<p className="italic">"{t.text}"</p>
							<div className="mt-4 font-bold">{t.name}</div>
							<div className="text-sm text-slate-500">{t.company}</div>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}
